var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.333 1.738c3.312 0 6 2.688 6 6s-2.688 6-6 6-6-2.688-6-6 2.688-6 6-6zm0 10.667A4.666 4.666 0 0012 7.738a4.665 4.665 0 00-4.667-4.666 4.665 4.665 0 00-4.666 4.666 4.665 4.665 0 004.666 4.667zm5.657.047l1.886 1.886-.943.943-1.886-1.886.943-.943z",
    fill: "#fff"
  })));
}
export default SvgIconSearch;